<style scoped lang="scss" type="text/scss">
.single-documentation-uploader {
  width: 12rem;
  height: 12rem;
  position: relative;

  .file-info {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
    padding: 1rem;
  }

  .head-avatar-container {
    width: 100%;
    height: 100%;

    &:hover {
      cursor: pointer;

      .shadow-placeholder {
        opacity: 1;
      }
    }

    .file-upload {
      font-size: 2.5rem;
      color: #eee;
      margin-bottom: 0.3rem;
    }

    .shadow-placeholder {
      opacity: 0;
      display: flex;
      flex-direction: column;
    }
  }
  .sanjiao {
    position: absolute;
    top: 0;
    right: 0;
    height: 60px;
    width: 60px;
    background-color: green;
    clip-path: polygon(0 0, 100% 100%, 100% 0);
    z-index: 99;
  }
  .sanjiao-text {
    position: absolute;
    top: -2px;
    right: -8px;
    color: #fff;
    font-size: 14px;
    transform: rotate(45deg);
    transform-origin: 0 50%;
    z-index: 99;
  }
}
</style>

<template>
  <el-tooltip
    effect="dark"
    :disabled="isActiveFileInfoNull"
    :content="showingFile.name"
    placement="bottom"
  >
    <i-single-upload
      ref="uploader"
      class="single-documentation-uploader"
      v-model="uploadFile"
      :limit-types="limitTypes"
      :limit-size="limitSize"
      :circular="circular"
      :is-image="false"
      :auto-upload="false"
      @on-add="onAdd"
      @on-uploading="onUploading"
    >
      <div class="sanjiao" v-if="activeFileInfo.url != null"></div>
      <div class="sanjiao-text" v-if="activeFileInfo.url != null">已提交</div>
      <tip-placeholder
        :reversed="reversed"
        :title="title"
        v-if="activeFileInfo.url == null"
      ></tip-placeholder>

      <file-info
        v-if="activeFileInfo.url != null"
        class="file-info"
        :file-name="showingFile.name"
        :file-size="showingFile.size"
        :file-extension-name="showingFile.extension_name"
        :fileType="showingFile.extension_name"
      >
      </file-info>
      <!-- 注：用自己的方式实现 auto-upload -->
      <normal-image
        class="head-avatar-container"
        :circular="circular"
        v-if="activeFileInfo.url == null"
      >
        <shadow-placeholder :circular="circular" class="shadow-placeholder">
          <span
            v-if="limitTypes[0] == '.mp4'"
            class="icon iconfont"
            style="font-size: 2.5rem"
            >&#xe6c9;</span
          >
          <i v-else class="icon file-upload">&#xe6ce;</i>
          <slot></slot>
        </shadow-placeholder>
      </normal-image>
    </i-single-upload>
  </el-tooltip>
</template>

<script>
import NormalImage from "../normal-image/index";
import ShadowPlaceholder from "../shadow-placeholder/index";
import ISingleUpload from "../i-uploader/single";
import FileInfo from "../file-info/index";
import TipPlaceholder from "./tip-placeholder";
import { extractExtensionName } from "../../utils/file/index";

export default {
  name: "",
  props: {
    value: {
      default() {
        return [];
      },
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    limitTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    limitSize: {
      type: Number,
      default: null,
    },
    circular: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "文件",
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    fileInfo: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    NormalImage,
    ShadowPlaceholder,
    ISingleUpload,
    FileInfo,
    TipPlaceholder,
  },
  data() {
    return {
      uploadFile: null,
      activeFileInfo: null,
    };
  },
  computed: {
    isActiveFileInfoNull() {
        // console.log(this.activeFileInfo)
      const activeFileInfo = this.activeFileInfo;
      return (
        null === activeFileInfo ||
        "" === activeFileInfo ||
        undefined === activeFileInfo
      );
    },
    showingFile() {
      // 用于页面显示的对象，仅为了防止空指针异常
      if (null !== this.activeFileInfo) {
        return this.activeFileInfo;
      } else {
        return {
          name: "",
          size: 0,
          extension_name: "",
        };
      }
    },
  },
  watch: {
    fileInfo: {
      immediate: true,
      handler(fileInfo) {
        this.activeFileInfo = fileInfo;
      },
    },
    uploadFile: {
      deep: true,
      handler(uploadFile) {
        this.$emit("input", uploadFile);
        if (uploadFile === null) {
          this.activeFileInfo = null;
        }
      },
    },
    value(value) {
      this.uploadFile = value;
    },
  },
  methods: {
    upload() {
      this.$refs.uploader.upload();
    },
    trigger() {
      this.$refs.uploader.trigger();
    },
    sync(file) {
      this.$emit("input", file);
    },
    onAdd(file) {
      this.activeFileInfo = getFileInfo(file.raw);
      // 将内部函数作为回调函数上抛
      this.$emit("on-add", file, this.upload);
      // 注：用自己的方式实现 auto-upload
      if (this.autoUpload) {
        this.upload();
      }
    },
    throwSuccess(response) {},
    throwFail(err) {
      this.activeFileInfo = null;
      this.uploadFile = null;
      // 后段完成后，测试文件上传反馈
    },
    onUploading(promise) {
      promise
        .then((response) => {
          // 由调用方最终确认是否上传成功
          this.$emit(
            "file-uploaded",
            response,
            this.throwSuccess,
            this.throwFail
          );
        })
        .catch((error) => {
          this.throwFail(error);
        });
    },
  },
};

function getFileInfo(file) {
  return {
    name: file.name,
    size: file.size,
    extension_name: extractExtensionName(file.name),
  };
}
</script>
